export { default } from "./useStandardAggregationsQuery";
